
import React from 'react';
import { connect } from 'react-redux';
import { getTimezone } from '../../selectors/common';
import { getDateTime } from '../../utils/common';

const mapToProps = (state) => ({
  getTimezone: getTimezone(state),
});

const PlayersTemplateFileRows = (props) => (props.playerTemplateFileList ? (
  props.playerTemplateFileList?.map((templateFile) => (
    <tr key={templateFile.id}>
      <td>{templateFile.fileName}</td>
      <td>{getDateTime(templateFile.indt, props.getTimezone)}</td>
      <td>{templateFile.inuser}</td>
      <td>
        {props.hasPermissionToDownload
          && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => props.downloadPlayersTemplatesFile(
                { fileRef: templateFile.id },
              )}
            >
              Download
            </button>
          )}
      </td>
    </tr>
  )))
  : (
    <tr><td>no result</td></tr>
  ));

export default connect(mapToProps)(PlayersTemplateFileRows);
